import getDataTrees from 'aveine-toolbox/src/store/adapter/dataTree'

/**
 * Declare un modele local aupres du dataTree de la toolbox.
 *
 * Pourquoi c'est necessaire : `requestSerializer` fait
 *
 *     let options = dataTree[entity]
 *     new JSONAPISerializer(type, options)
 *
 * et `dataTree` est construit une fois pour toutes a partir d'une LISTE DE
 * MODELES ECRITE EN DUR dans aveine-toolbox. Un modele qui n'y figure pas —
 * c'est le cas des notres, qui vivent dans ce depot — donne `options ===
 * undefined`, et jsonapi-serializer plante des son constructeur sur
 * « Cannot read properties of undefined (reading 'topLevelLinks') ».
 *
 * La lecture seule ne passe pas par la, d'ou une liste qui s'affiche
 * parfaitement et un enregistrement qui echoue.
 *
 * On reconstruit donc l'entree avec les MEMES regles que
 * `dataTree.js:getDataTree`, qui n'est pas exporte.
 *
 * La version d'origine (REDMINE-12958) aplatissait tous les champs en
 * `attributes` : les deux referentiels de degustation n'avaient que des
 * scalaires et un objet de traductions, et elle notait qu'il faudrait reprendre
 * la recursion le jour ou l'un d'eux gagnerait une relation. Les quizz et le vin
 * du mois (REDMINE-12962) en ont — reponses, etiquettes, vin — d'ou cette
 * reecriture.
 */

/**
 * Bati l'entree d'un modele et, recursivement, celle des modeles qu'il
 * reference. Reproduit `getDataTree` de la toolbox, y compris ses subtilites.
 *
 * @param {Object} model  Le modele vuex-orm a declarer.
 * @param {Object} trees  Le cache partage rendu par `getDataTrees()`.
 * @returns {Object} L'entree du modele dans le cache.
 */
function buildTree (model, trees) {
  if (!model) return undefined
  // Un modele deja connu de la toolbox (Wine, par exemple) est reutilise tel
  // quel : on ne reconstruit jamais une entree existante.
  if (trees[model.entity]) return trees[model.entity]

  // Identique a la toolbox : le type JSON:API vient de $entity_name, en kebab.
  const typeForAttribute = function (attribute, fields) {
    if (fields && fields.$entity_name) {
      return fields.$entity_name.replace(/_/g, '-')
    }
    return null
  }

  const attributes = []
  const tree = { plurializeType: false, typeForAttribute, attributes }

  // Enregistre AVANT de parcourir les champs, exactement comme la toolbox :
  // c'est ce qui casse les cycles. Quiz reference QuizAnswer qui reference
  // Quiz ; sans cette ligne, la recursion serait infinie.
  trees[model.entity] = tree

  const staticReadOnlyFields = ['$entity_name', '$isNew', 'created_at', 'updated_at', 'deleted']
  const fields = model.getFields()

  for (const name in fields) {
    if (!model.readOnlyFields.includes(name) && !staticReadOnlyFields.includes(name)) {
      // `parent` porte le modele vise par un belongsTo, `related` celui d'un
      // hasMany. Une relation est declaree DEUX fois : dans `tree[name]` pour
      // que jsonapi-serializer sache la serialiser, et dans `attributes` pour
      // qu'il la considere tout court.
      if (fields[name].parent) {
        tree[name] = buildTree(fields[name].parent, trees)
        tree[name].ref = 'id'
      } else if (fields[name].related) {
        tree[name] = buildTree(fields[name].related, trees)
        tree[name].ref = 'id'
      }
      attributes.push(name)
    }
  }

  return tree
}

export default function registerDataTree (model) {
  return buildTree(model, getDataTrees())
}
